import * as React from 'react';

import {Button} from 'shells/button/button';
import type {ButtonSize} from 'shells/button/types';

import {CreateMeetingModal} from './create-modals/multi-host/create-meeting-modal';
import {useHasFullSchedulerAccess} from './create-modals/multi-host/use-has-full-scheduler-access';

type Props = {
    size?: ButtonSize;
    isAdmin?: boolean;
    /** If true, the create meeting modal opens automatically on mount */
    initialOpen?: boolean;
};

export function CreateNewMeetingButton(props: Props) {
    const [isCreating, setIsCreating] = React.useState<boolean>(Boolean(props.initialOpen));
    const {hasFullSchedulerAccess} = useHasFullSchedulerAccess();

    return (
        <>
            <Button
                variant='primary'
                size={props.size || 'big'}
                onClick={() => setIsCreating(true)}
            >
                + Create new meeting
            </Button>
            {isCreating && (
                <CreateMeetingModal
                    onClose={() => setIsCreating(false)}
                    hasFullSchedulerAccess={hasFullSchedulerAccess}
                    isAdmin={props.isAdmin}
                />
            )}
        </>
    );
}
